import { Badge, HoverCard, HoverCardContent, HoverCardTrigger } from '@e2n/ui';
import { HoverCard as HoverCardPrimitive } from 'radix-ui';

export function QualifikationBadge({
  names,
  label,
  isRemaining = false,
  cardElement,
}: {
  names: string[];
  label: string;
  isRemaining?: boolean;
  cardElement: HTMLDivElement | null;
}) {
  const hasDetails =
    isRemaining || label.endsWith('…') || label.endsWith('...');
  const accessibleLabel = isRemaining ? label : names[0];
  const badge = (
    <Badge
      variant="outline"
      type="pill"
      className="max-w-full min-w-0 shrink-0 bg-white hover:bg-neutrals-200">
      <span className="truncate">{label}</span>
    </Badge>
  );

  if (!hasDetails) return badge;

  return (
    <HoverCard openDelay={0}>
      <HoverCardTrigger
        asChild
        tabIndex={0}
        aria-label={accessibleLabel}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}>
        {badge}
      </HoverCardTrigger>
      <HoverCardPrimitive.Portal container={cardElement}>
        <HoverCardContent
          align="start"
          side="top"
          collisionBoundary={cardElement}
          collisionPadding={16}
          sticky="always"
          aria-label={accessibleLabel}
          className="w-[min(16rem,100cqw)] max-h-[min(16rem,var(--radix-hover-card-content-available-height))] overflow-y-auto bg-white p-3 text-xs text-neutrals-700"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}>
          <ul className="flex flex-col gap-2">
            {names.map((name) => (
              <li key={name} className="wrap-break-word">
                {name}
              </li>
            ))}
          </ul>
        </HoverCardContent>
      </HoverCardPrimitive.Portal>
    </HoverCard>
  );
}
